import { formData, validateForm, Validations, bindFormValidationEvents, sendForm } from '../utils';

export function registerAccessibilityBlock(): void {
    const FORM_ID = 'accessibility-form';
    const VALIDATIONS: Validations = {
        pagelink: {
            message: 'Sidolänksfältet får inte lämnas tomt.',
            required: true,
        },
        device: {
            message: 'Hjälpmedelsfältet får inte lämnas tomt.',
            required: true,
        },
    };

    const $form = document.getElementById(FORM_ID) as HTMLFormElement;

    function onFormSubmit(): void {
        // Send form
        const data = formData($form);

        if (!validateForm($form, VALIDATIONS, data)) {
            console.error('Validation failed for form');
            return;
        }

        sendForm({
            form: $form,
            type: $form.method || 'POST',
            url: $form.action,
            data,
        });
    }

    // Initialize events
    if ($form != null) {
        // Bind form validation events
        bindFormValidationEvents($form, onFormSubmit);
    }
}
